import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { CHANNEL_SOURCE, EMPOWER_TYPE, type Channels } from '@eureka/shared/login-sdk';

export interface LoginDialogService {
    open(): Promise<void>
}

@injectable()
export class LoginDialogServiceImpl implements LoginDialogService {
    private _channels: Channels = {
        from_page: EMPOWER_TYPE.RD_TRIZ,
        channel_source: CHANNEL_SOURCE.AIR_EUREKA,
    }

    open() {
        return import('@eureka/shared/login-sdk').then(({ loginSDK }) => {
            loginSDK.setChannels(this._channels);
            return loginSDK.open({
                withoutClose: true,
            }).then(() => {
                window.location.reload();
            });
        });
    }
}

export const LoginDialogService = Symbol('LoginDialogService');
